<template>
  <div>
    <div
      class="card card-custom gutter-b"
      v-show="
        (fgModoPR == 'R' && fgDashboardReceber) ||
          (fgModoPR == 'P' && fgDashboardPagar)
      "
    >
      <div class="card-body">
        <!--begin::Top-->
        <div class="d-flex">
          <!--begin: Info-->
          <div class="flex-grow-1">
            <!--begin::Title-->
            <div
              class="d-flex align-items-center justify-content-between flex-wrap mt-2"
            >
              <div class="mr-3" v-show="!emitentePrincipal.RAZAO_SOCIAL">
                <img
                  :src="
                    fgModoPR == 'R'
                      ? 'media/logos/Pulse-1s-200px.gif'
                      : 'media/logos/Pulse-1s-200pxR.gif'
                  "
                  style="height: 100px;"
                />
              </div>
              <!--begin::User-->
              <transition name="fade" enter-active-class="animated fadeIn">
                <div class="mr-3" v-show="emitentePrincipal.RAZAO_SOCIAL">
                  <!--begin::Name-->
                  <a
                    href="javascript:;"
                    class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3"
                    :class="{
                      receber: fgModoPR == 'R',
                      pagar: fgModoPR == 'P'
                    }"
                  >
                    {{
                      emitentePrincipal.RAZAO_SOCIAL
                        ? emitentePrincipal.RAZAO_SOCIAL.toUpperCase()
                        : ""
                    }}
                    <i class="flaticon2-correct text-success icon-md ml-2"></i>
                  </a>
                  <!--end::Name-->
                  <!--begin::Contacts-->
                  <div class="d-flex flex-wrap my-2">
                    <a
                      href="javascript:;"
                      class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      :class="{
                        receber: fgModoPR == 'R',
                        pagar: fgModoPR == 'P'
                      }"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                        <!--begin::Svg Icon | path:/metronic/theme/html/demo1/dist/assets/media/svg/icons/Communication/Mail-notification.svg-->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect x="0" y="0" width="24" height="24" />
                            <path
                              d="M21,12.0829584 C20.6747915,12.0283988 20.3407122,12 
                                                                20,12 C16.6862915,12 14,14.6862915 14,18 C14,18.3407122 14.0283988,18.6747915 
                                                                14.0829584,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 
                                                                3.8954305,6 5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,12.0829584 Z 
                                                                M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 
                                                                5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 
                                                                4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 
                                                                C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 
                                                                L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 
                                                                C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                              fill="#000000"
                            />
                            <circle
                              fill="#000000"
                              opacity="0.3"
                              cx="19.5"
                              cy="17.5"
                              r="2.5"
                            />
                          </g>
                        </svg>
                        <!--end::Svg Icon-->
                      </span>
                      {{ emitentePrincipal.E_MAIL }}
                    </a>
                    <a
                      href="#"
                      class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      :class="{
                        receber: fgModoPR == 'R',
                        pagar: fgModoPR == 'P'
                      }"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                        <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2020-12-10-081610/theme/html/demo1/dist/../src/media/svg/icons/Map/Position.svg-->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect x="0" y="0" width="24" height="24" />
                            <path
                              d="M19,11 L21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 
                                                                21,13 L19,13 C18.4477153,13 18,12.5522847 18,12 C18,11.4477153 18.4477153,11 19,11 Z M3,11 
                                                                L5,11 C5.55228475,11 6,11.4477153 6,12 C6,12.5522847 5.55228475,13 5,13 L3,13 C2.44771525,13 
                                                                2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 Z M12,2 C12.5522847,2 13,2.44771525 13,3 
                                                                L13,5 C13,5.55228475 12.5522847,6 12,6 C11.4477153,6 11,5.55228475 11,5 L11,3 C11,2.44771525 
                                                                11.4477153,2 12,2 Z M12,18 C12.5522847,18 13,18.4477153 13,19 L13,21 C13,21.5522847 12.5522847,22 
                                                                12,22 C11.4477153,22 11,21.5522847 11,21 L11,19 C11,18.4477153 11.4477153,18 12,18 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              opacity="0.3"
                            />
                            <circle
                              fill="#000000"
                              opacity="0.3"
                              cx="12"
                              cy="12"
                              r="2"
                            />
                            <path
                              d="M12,17 C14.7614237,17 17,14.7614237 17,12 C17,9.23857625 14.7614237,7 12,7 C9.23857625,7 
                                                                7,9.23857625 7,12 C7,14.7614237 9.23857625,17 12,17 Z M12,19 C8.13400675,19 5,15.8659932 5,12 
                                                                C5,8.13400675 8.13400675,5 12,5 C15.8659932,5 19,8.13400675 19,12 C19,15.8659932 15.8659932,19 12,19 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                            />
                          </g>
                        </svg>
                        <!--end::Svg Icon-->
                      </span>
                      {{ cnpj }}
                    </a>
                    <a
                      href="#"
                      class="text-muted text-hover-primary font-weight-bold"
                      :class="{
                        receber: fgModoPR == 'R',
                        pagar: fgModoPR == 'P'
                      }"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                        <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2020-12-10-081610/theme/html/demo1/dist/../src/media/svg/icons/Text/Bullet-list.svg-->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect x="0" y="0" width="24" height="24" />
                            <path
                              d="M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 
                                                                L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 
                                                                C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 
                                                                9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 
                                                                21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 
                                                                9.67157288,15 10.5,15 Z"
                              fill="#000000"
                            />
                            <path
                              d="M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 
                                                                7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 
                                                                C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 
                                                                Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 
                                                                7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z"
                              fill="#000000"
                              opacity="0.3"
                            />
                          </g>
                        </svg>
                        <!--end::Svg Icon-->
                      </span>
                      {{ dataAdmissao }}
                    </a>
                  </div>
                  <!--end::Contacts-->
                </div>
              </transition>
              <!--begin::User-->
              <!--begin::Actions-->
              <div class="my-lg-0 my-1">
                <router-link to="/incluir-venda" v-slot="{ href, navigate }">
                  <a
                    :href="href"
                    @click="navigate"
                    class="btn btn-sm font-weight-bolder text-uppercase"
                    :class="{
                      'btn-primary': fgModoPR == 'R',
                      'btn-danger': fgModoPR == 'P'
                    }"
                  >
                    Novo título
                  </a>
                </router-link>
              </div>
              <!--end::Actions-->
            </div>
            <!--end::Title-->
            <!--begin::Content-->
            <div
              class="d-flex align-items-center flex-wrap justify-content-between"
            >
              <!--begin::Description-->
              <div
                class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5"
                v-show="!emitentePrincipal.RAZAO_SOCIAL"
              >
                <img
                  :src="
                    fgModoPR == 'R'
                      ? 'media/logos/Pulse-1s-200px.gif'
                      : 'media/logos/Pulse-1s-200pxR.gif'
                  "
                  style="height: 100px;"
                />
              </div>
              <transition name="fade" enter-active-class="animated fadeIn">
                <div
                  class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5"
                  v-show="emitentePrincipal.RAZAO_SOCIAL"
                >
                  Data do cadastro: {{ dataAdmissao }}<br />
                  CNPJ: {{ cnpj }}<br />
                  Telefone: {{ telefone }}
                </div>
              </transition>
              <!--end::Description-->
              <!--begin::Progress-->
              <div class="d-flex mt-4 mt-sm-0">
                <img
                  :src="
                    fgModoPR == 'R'
                      ? 'media/logos/Pulse-1s-200px.gif'
                      : 'media/logos/Pulse-1s-200pxR.gif'
                  "
                  v-show="fgLoading6meses"
                />
                <transition name="fade" enter-active-class="animated fadeIn">
                  <GChart 
                    v-if="(chartData.length > 1) && (!fgLoading6meses)" 
                    type="ColumnChart"
                    :data="chartData"
                    :options="chartOptions"
                  />
                </transition>
              </div>
              <!--end::Progress-->
            </div>
            <!--end::Content-->
          </div>
          <!--end::Info-->
        </div>
        <!--end::Top-->
      </div>
    </div>
    <div class="tab-content mt-5" id="myTabContent">
      <div class="tab-pane fade show active" role="tabpanel">
        <div class="row">
          <div
            class="col-xxl-4"
            v-show="
              (fgModoPR == 'R' && fgDashboardReceber) ||
                (fgModoPR == 'P' && fgDashboardPagar)
            "
          >
            <MixedWidget1 ref="graficoDash"></MixedWidget1>
          </div>
          <div
            :class="{
              'col-xxl-8':
                (fgModoPR == 'R' && fgDashboardReceber) ||
                (fgModoPR == 'P' && fgDashboardPagar),
              'col-xxl-12': !(
                (fgModoPR == 'R' && fgDashboardReceber) ||
                (fgModoPR == 'P' && fgDashboardPagar)
              )
            }"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="card card-custom gutter-b">
                  <div class="card-body">
                    <!--begin::Bottom-->
                    <div class="d-flex align-items-center flex-wrap">
                      <!--begin: Item-->
                      <div
                        class="d-flex align-items-center flex-lg-fill mr-5 my-1"
                      >
                        <span class="mr-4">
                          <i
                            class="flaticon-piggy-bank icon-2x text-muted font-weight-bold"
                          ></i>
                        </span>
                        <div class="d-flex flex-column text-dark-75">
                          <span class="font-weight-bolder font-size-sm"
                            >TICKET MÉDIO</span
                          >
                          <span class="font-weight-bolder font-size-h5">
                            {{ ticketMedio() }}
                          </span>
                        </div>
                      </div>
                      <!--end: Item-->
                      <!--begin: Item-->
                      <div
                        class="d-flex align-items-center flex-lg-fill mr-5 my-1"
                      >
                        <span class="mr-4">
                          <i
                            class="flaticon-confetti icon-2x text-muted font-weight-bold"
                          ></i>
                        </span>
                        <div class="d-flex flex-column text-dark-75">
                          <span class="font-weight-bolder font-size-sm"
                            >Nº DE TÍTULOS</span
                          >
                          <span class="font-weight-bolder font-size-h5">
                            {{ fluxosDeCaixaQuantidadeTotal }}
                          </span>
                        </div>
                      </div>
                      <!--end: Item-->
                      <!--begin: Item-->
                      <div
                        class="d-flex align-items-center flex-lg-fill mr-5 my-1"
                      >
                        <span class="mr-4">
                          <i
                            class="flaticon-pie-chart icon-2x text-muted font-weight-bold"
                          ></i>
                        </span>
                        <div class="d-flex flex-column text-dark-75">
                          <span class="font-weight-bolder font-size-sm"
                            >EMITENTES PF</span
                          >
                          <span class="font-weight-bolder font-size-h5">
                            {{ fluxosDeCaixaQuantidadeEmitentesPF }}
                          </span>
                        </div>
                      </div>
                      <!--end: Item-->
                      <!--begin: Item-->
                      <div
                        class="d-flex align-items-center flex-lg-fill mr-5 my-1"
                      >
                        <span class="mr-4">
                          <i
                            class="flaticon-pie-chart icon-2x text-muted font-weight-bold"
                          ></i>
                        </span>
                        <div class="d-flex flex-column text-dark-75">
                          <span class="font-weight-bolder font-size-sm"
                            >EMITENTES PJ</span
                          >
                          <span class="font-weight-bolder font-size-h5">
                            {{ fluxosDeCaixaQuantidadeEmitentesPJ }}
                          </span>
                        </div>
                      </div>
                      <!--end: Item-->
                    </div>
                    <!--end::Bottom-->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mrg-bottom-cel">
                <label>Ordenação por:</label>
                <b-form-select
                  v-model="ordenacaoFiltroTipo"
                  :options="ordenacaoFiltros"
                  :disabled="fgLoading"
                  @change="setOrdenacaoData"
                ></b-form-select>
              </div>
              <div class="col-md-2 mrg-bottom-cel">
                <label>Busca por:</label>
                <b-form-select
                  v-model="dataFiltroTipo"
                  :options="dataFiltros"
                  :disabled="fgLoading"
                  @change="setFiltroData"
                ></b-form-select>
              </div>
              <div class="col-md-8" v-show="dataFiltroTipo != 'emitente'">
                <label>Data busca:</label>
                <date-range-picker
                  ref="date-range-picker"
                  opens="left"
                  :locale-data="localData"
                  :autoApply="true"
                  :disabled="fgLoading"
                  v-model="dateRange"
                  :ranges="ranges"
                  @update="updateDatas"
                  style="width: 100%"
                >
                  <template v-slot:input="picker">
                      <div v-if="(picker.startDate) && (picker.endDate)" style="min-width: 350px;">
                        {{ formataDataObject(picker.startDate) }} à {{ formataDataObject(picker.endDate) }}
                      </div>
                  </template>
                </date-range-picker>
              </div>
              <div class="col-md-8" v-show="dataFiltroTipo == 'emitente'">
                <SearchBoxEmitente 
                  ref="emitente" 
                  v-model="idEmitenteFiltro" 
                  :hidelabel="true" 
                  :incluir="false" 
                  :alterar="false" 
                  :disabled="fgLoading" 
                  style="position: absolute; z-index: 999999; width: calc(100% - 26px);"
                  @change="buscaPorEmitente"
                  @descricao="alterouEmitente"
                />
              </div>
            </div>
            <div class="row" style="margin-top: 10px;">
              <div class="col-md-12">
                <div class="d-flex align-items-center" v-if="fgLoading">
                  <strong style="margin-right: 10px;">Carregando...</strong>
                  <b-spinner class="ml-auto"></b-spinner>
                </div>
              </div>
            </div>
            <ul class="nav justify-content-center nav-tabs nav-tabs-line">
              <li class="nav-item">
                <a
                  class="nav-link"
                  @click="setTabIndex(0)"
                  :class="{
                    active: fgFiltroAbas == 0,
                    receber: fgModoPR == 'R',
                    pagar: fgModoPR == 'P'
                  }"
                  href="javascript:;"
                  >Títulos</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  @click="setTabIndex(1)"
                  :class="{
                    active: fgFiltroAbas == 1,
                    receber: fgModoPR == 'R',
                    pagar: fgModoPR == 'P'
                  }"
                  href="javascript:;"
                  >Títulos quitados</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  @click="setTabIndex(2)"
                  :class="{
                    active: fgFiltroAbas == 2,
                    receber: fgModoPR == 'R',
                    pagar: fgModoPR == 'P'
                  }"
                  href="javascript:;"
                  >Títulos em aberto</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  @click="setTabIndex(3)"
                  :class="{
                    active: fgFiltroAbas == 3,
                    receber: fgModoPR == 'R',
                    pagar: fgModoPR == 'P'
                  }"
                  href="javascript:;"
                  v-if="fgModoPR == 'R'"
                  >Títulos enviados</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  @click="setTabIndex(4)"
                  :class="{
                    active: fgFiltroAbas == 4,
                    receber: fgModoPR == 'R',
                    pagar: fgModoPR == 'P'
                  }"
                  href="javascript:;"
                  v-if="fgModoPR == 'R'"
                  >Títulos gerados</a
                >
              </li>
            </ul>
            <ListWidget9
              :indice="fgFiltroAbas"
              @selecionarFluxo="selecionarFluxo"
            ></ListWidget9>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--<div class="col-lg-12 col-xxl-12">
                <ListWidget3></ListWidget3>
            </div>
            <div class="col-xxl-4">
                <StatsWidget7></StatsWidget7>
                <StatsWidget12></StatsWidget12>
            </div>
            <div class="col-xl-8">
                <AdvancedTableWidget2></AdvancedTableWidget2>
            </div>
            <div class="col-xxl-6">
                <ListWidget14></ListWidget14>
            </div>
            <div class="col-xxl-6">
                <ListWidget15></ListWidget15>
            </div>

            <div class="col-xxl-4">
                <ListWidget8></ListWidget8>
            </div>
            <div class="col-xxl-8">
                <ListWidget2></ListWidget2>
            </div>-->
    </div>
  </div>
</template>

<style lang="scss">
.nav-tabs > li {
  float: none;
  display: inline-block;
  zoom: 1;
}

.nav-tabs {
  text-align: center;
}

.margin-btn-5 {
  margin-right: 5px;
}

a.text-hover-primary.receber:hover i,
.text-hover-primary.receber:hover i {
  color: #1bc5bd !important;
}

a.text-hover-primary.pagar:hover i,
.text-hover-primary.pagar:hover i {
  color: #f64e60 !important;
}

a.text-hover-primary.pagar:hover .svg-icon svg g [fill],
.text-hover-primary.pagar:hover .svg-icon svg g [fill] {
  fill: #f64e60;
}

a.text-hover-primary.receber:hover .svg-icon svg g [fill],
.text-hover-primary.receber:hover .svg-icon svg g [fill] {
  fill: #1bc5bd;
}

.nav .nav-link.active.receber {
  color: #1bc5bd;
}

.nav .nav-link.active.pagar {
  color: #f64e60;
}

.nav.nav-tabs.nav-tabs-line .nav-link.active.pagar {
  border-bottom: 1px solid #f64e60;
}

.nav.nav-tabs.nav-tabs-line .nav-link.active.receber {
  border-bottom: 1px solid #1bc5bd;
}

.nav.nav-tabs.nav-tabs-line .nav-link.pagar:hover:not(.disabled) {
  border-bottom: 1px solid #f64e60;
}

.nav.nav-tabs.nav-tabs-line .nav-link.receber:hover:not(.disabled) {
  border-bottom: 1px solid #1bc5bd;
}

.nav .nav-link.pagar:hover:not(.disabled) {
  color: #f64e60;
}

.nav .nav-link.receber:hover:not(.disabled) {
  color: #1bc5bd;
}

.dropzone-custom-content {
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}

.calendars .ranges {
  max-width: 140px;
}

.vue-daterange-picker .reportrange-text {
  padding-top: 9px;
  text-align: center;
  border: 1px solid #E4E6EF;
}

.vue-daterange-picker .reportrange-text i {
  display: none;
}

@media(max-width: 767px) {
  .mrg-bottom-cel {
    margin-bottom: 8px;
  }
}
</style>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import AdvancedTableWidget2 from "@/view/content/widgets/advance-table/Widget2.vue";
import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
// import ListWidget2 from "@/view/content/widgets/list/Widget2.vue";
// import ListWidget3 from "@/view/content/widgets/list/Widget3.vue";
// import ListWidget8 from "@/view/content/widgets/list/Widget8.vue";
import ListWidget9 from "@/view/content/widgets/list/Widget9.vue";
// import ListWidget14 from "@/view/content/widgets/list/Widget14.vue";
// import ListWidget15 from "@/view/content/widgets/list/Widget15.vue";
// import StatsWidget7 from "@/view/content/widgets/stats/Widget7.vue";
// import StatsWidget12 from "@/view/content/widgets/stats/Widget12.vue";
import Swal from "sweetalert2";
import { GChart } from 'vue-google-charts';

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

import SearchBoxEmitente from "@/../../components-spirit/SearchBox/SearchBoxEmitente.vue";

export default {
  name: "dashboard",
  data() {
    return {
      hoje: moment().format("DD/MM/YYYY"),
      ordenacaoFiltroTipo: window.localStorage.getItem("validadeOrdenacaoFiltroTipo") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("ordenacaoFiltroTipo") ?
        window.localStorage.getItem("ordenacaoFiltroTipo") : "vencimento",
      dataFiltroTipo: window.localStorage.getItem("validadeDataFiltroTipo") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("dataFiltroTipo") ?
        window.localStorage.getItem("dataFiltroTipo") : "vencimento",
      dataFiltros: [
        { value: "vencimento", text: "Vencimento" },
        { value: "pagamento", text: "Pagamento" },
        { value: "credito", text: "Crédito" },
        { value: "emissao", text: "Emissão" },
        { value: "inclusao", text: "Inclusão" },
        { value: "alteracao", text: "Alteração" },
        { value: "emitente", text: "Emitente" }
      ],
      ordenacaoFiltros: [
        { value: "vencimento", text: "Vencimento" },
        { value: "pagamento", text: "Pagamento" },
        { value: "credito", text: "Crédito" },
        { value: "emissao", text: "Emissão" },
        { value: "inclusao", text: "Inclusão" },
        { value: "alteracao", text: "Alteração" },
        { value: "emitente", text: "Emitente" },
        { value: "valor", text: "Valor" }
      ],
      chartData: [],
      chartOptions: {
        colors: ["rgb(27, 197, 189)"],
        legend: {position: 'none'},
        backgroundColor: {
          fill: "transparent"
        },
        hAxis: {
          textStyle:{color: '#b5b5c3'}
        },
        vAxis: {
          textStyle:{color: '#b5b5c3'},
          textPosition: "none",
          baselineColor: "transparent",
          gridlineColor: "transparent"
        },
        chart: {
          title: 'Company Performance',
          subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        },
        chartArea:{
          left:10,
          right:10,
          bottom:20,
          top:20,
          width:"80%",
          height:"100%"
        }
      },
      fluxoDetalhado: {},
      dateRange: {
        startDate: null,
        endDate: null
      },
      localData: {
        firstDay: 1,
        format: "yyyy-mm-dd HH:mm:ss",
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      },
      ranges: {
        'Hoje': [moment().toDate(), moment().toDate()],
        'Ontem': [moment().subtract(1, "days").toDate(), moment().subtract(1, "days").toDate()],
        'Mês atual': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
        'Mês passado': [moment().subtract(1, "month").startOf('month').toDate(), moment().subtract(1, "month").endOf('month').toDate()],
        'Ano atual': [moment().startOf('year').toDate(), moment().endOf('year').toDate()]
      },
      idEmitenteFiltro: ''
    };
  },
  components: {
    GChart,
    //AdvancedTableWidget2,
    MixedWidget1,
    //ListWidget2,
    //ListWidget3,
    //ListWidget8,
    ListWidget9,
    //ListWidget14,
    //ListWidget15,
    //StatsWidget7,
    //StatsWidget12
    DateRangePicker,
    SearchBoxEmitente
  },
  mounted() {
    let vm = this;
    moment.locale('pt-br');

    this.dateRange.startDate = moment(this.fgDataInicio, "YYYY-MM-DD").toDate();
    this.dateRange.endDate = moment(this.fgDataFim, "YYYY-MM-DD").toDate();

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);

    if (this.verificado) {
      vm.buscarFluxo6Meses();

      if (!vm.fgLoading) {
        vm.sairFluxoDetalhado();
      }
    } else {
      window.addEventListener(
        "autorizado",
        function() {
          vm.buscarFluxo6Meses();

          if (!vm.fgLoading) {
            vm.sairFluxoDetalhado();
          }
        },
        false
      );
    }

    if((this.fgEmitente) && (this.fgEmitenteDescricao)) {
      this.$refs.emitente.selecionar({
        ID: this.fgEmitente,
        DESCRICAO: this.fgEmitenteDescricao
      });
    }

    this.$root.$on("trocaTipoPR", function() {
      vm.trocaTipoGrafico();
      vm.buscarFluxo6Meses();
      vm.updatefgFiltroAbas(0);
    });
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "emitentePrincipal",
      "fluxosDeCaixa",
      "verificado",
      "fluxosDeCaixa6Meses",
      "fgDataInicio",
      "fgDataFim",
      "fgEmpresa",
      "fgProjeto",
      "fgPlanoFinanceiro",
      "fgCentroDeResponsabilidade",
      "fgPortador",
      "fgLoading6meses",
      "fgLoading",
      "fgModoPR",
      "fgDashboardReceber",
      "fgDashboardPagar",
      "fluxoDeCaixaBusca",
      "fgFiltroAbas",
      "fgDataFiltroTipo",
      "fluxosDeCaixaQuantidadeTotal",
      "fluxosDeCaixaQuantidadeEmitentesPF",
      "fluxosDeCaixaQuantidadeEmitentesPJ",
      "fluxosDeCaixaQuantidadeValor",
      "fgEmitente",
      "fgEmitenteDescricao",
      "fgOrdenacaoFiltroTipo"
    ]),
    cnpj() {
      let dado = "";

      if (this.emitentePrincipal) {
        if (this.emitentePrincipal.CGC_CPF) {
          let x = this.emitentePrincipal.CGC_CPF.replace(/\D/g, "").match(
            /(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/
          );
          dado = !x[2]
            ? x[1]
            : x[1] +
              "." +
              x[2] +
              "." +
              x[3] +
              "/" +
              x[4] +
              (x[5] ? "-" + x[5] : "");
        }
      }

      return dado;
    },
    dataAdmissao() {
      let dado = "";

      if (this.emitentePrincipal) {
        if (this.emitentePrincipal.DATA_ADMISSAO) {
          dado = moment(
            this.emitentePrincipal.DATA_ADMISSAO,
            "YYYYMMDD[T]HHmmss"
          ).format("DD/MM/YYYY");
        }
      }

      return dado;
    },
    telefone() {
      let dado = "";

      if (this.emitentePrincipal) {
        if (this.emitentePrincipal.TELEFONES) {
          if (this.emitentePrincipal.TELEFONES.length) {
            if (this.emitentePrincipal.TELEFONES[0].DDD) {
              dado += this.emitentePrincipal.TELEFONES[0].DDD;
            }
            dado += this.emitentePrincipal.TELEFONES[0].TELEFONE;
          }
        }
      }

      return dado;
    }
  },
  methods: {
    ...mapActions([
      "getFluxosDeCaixa6Meses",
      "getEmitenteEmails",
      "getEnviarEmailFluxo",
      "getEnviarSMSFluxo",
      "getMulta",
      "updateFgLoading6Meses",
      "updatePagarTitulo",
      "updateDataVencimento",
      "updateFgDataInicio",
      "updateFgDataFim",
      "getFluxosDeCaixa",
      "updateFgLoading",
      "updatefgFiltroAbas",
      "updatefgDataFiltroTipo",
      "getGED",
      "getGEDFile",
      "getExcGEDFile",
      "getZeraFluxosDeCaixa",
      "updatefgEmitente",
      "updatefgEmitenteDescricao",
      "updatefgOrdenacaoFiltroTipo"
    ]),
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
    ticketMedio() {
      if (this.fluxosDeCaixaQuantidadeValor > 0) {
        return (
          this.fluxosDeCaixaQuantidadeValor /
          (this.fluxosDeCaixaQuantidadeEmitentesPF +
            this.fluxosDeCaixaQuantidadeEmitentesPJ)
        ).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL"
        });
      } else {
        return this.fluxosDeCaixaQuantidadeValor.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL"
        });
      }
    },
    setFiltroData() {
      this.updatefgDataFiltroTipo(this.dataFiltroTipo);

      if(this.dataFiltroTipo != "emitente") {
        this.buscarFluxos();
      }
    },
    setOrdenacaoData() {
      this.updatefgOrdenacaoFiltroTipo(this.ordenacaoFiltroTipo);

      this.buscarFluxos();
    },
    setTabIndex(index) {
      if (!this.fgLoading) {
        this.updatefgFiltroAbas(index);
        this.buscarFluxos();
      }
    },
    async buscarFluxo6Meses() {
      this.updateFgLoading6Meses(true);

      let dados = await this.getFluxosDeCaixa6Meses({
        tipo: this.fgModoPR,
        empresa: 0,
        projeto: 0,
        planoFinanceiro: 0,
        centroDeResponsabilidade: 0,
        portador: 0
      });

      this.montaGrafico6Meses(dados);

      dados = await this.getFluxosDeCaixa6Meses({
        tipo: this.fgModoPR,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador
      });

      this.updateFgLoading6Meses(false);
      
      this.$nextTick(() => {
        this.$refs.graficoDash.montaGrafico6Meses(dados);
      });
    },
    montaGrafico6Meses(dados) {
      let vm = this;

      let vendas = [];

      this.chartData = [];

      Object.keys(dados).forEach(function(item) {
        if(dados[item].VALOR) {
          let valor = dados[item].VALOR;

          if (valor) {
            vendas.unshift(valor.toFixed(2));
          } else {
            vendas.unshift(0);
          }

          let mes = "";
          if (item == "MES1") {
            mes = "Jan";
          } else if (item == "MES2") {
            mes = "Fev";
          } else if (item == "MES3") {
            mes = "Mar";
          } else if (item == "MES4") {
            mes = "Abr";
          } else if (item == "MES5") {
            mes = "Mai";
          } else if (item == "MES6") {
            mes = "Jun";
          } else if (item == "MES7") {
            mes = "Jul";
          } else if (item == "MES8") {
            mes = "Ago";
          } else if (item == "MES9") {
            mes = "Set";
          } else if (item == "MES10") {
            mes = "Out";
          } else if (item == "MES11") {
            mes = "Nov";
          } else if (item == "MES12") {
            mes = "Dez";
          }

          vm.chartData.unshift(
            [
              mes, 
              {v: valor, f: valor.toLocaleString("pt-br", {style: "currency", currency: "BRL"})}
            ]
          );
        }
      });
      
      this.chartData.unshift(['Mês', 'Títulos Emitidos']);
    },
    formatarDatasFiltro() {
      return (
        moment(this.fgDataInicio, "YYYY-MM-DD").format("DD/MM/YYYY") +
        " à " +
        moment(this.fgDataFim, "YYYY-MM-DD").format("DD/MM/YYYY")
      );
    },
    async selecionarFluxo(obj) {
      if (obj.opcao == 1) {
        this.$router.push({
          path: "/cadastros/emitente/" + obj.fluxo.ID_EMITENTE
        });
      } else {
        this.$router.push({
          path: "/alterar-venda/" + obj.fluxo.ID_FLUXO_DE_CAIXA
        });
      }
    },
    formataData(data) {
      if (data) {
        return moment(data, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    formataDataObject(data) {
      if (data) {
        return moment(data).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    trocaTipoGrafico() {
      let vm = this;
      this.$nextTick(() => {
        vm.chartOptions = {
          ...vm.chartOptions,
          ...{
            colors: [vm.fgModoPR == "R" ? "#1BC5BD" : "#F64E60", "#ffffff"]
          }
        };
      });
    },
    async pagar() {
      let resultado = await this.updatePagarTitulo({
        fluxosDeCaixa: [
          { ID_FLUXO_DE_CAIXA: this.fluxoDetalhado.ID_FLUXO_DE_CAIXA }
        ],
        DESCRICAO: this.fluxoDetalhado.PROJETO
          ? this.fluxoDetalhado.PROJETO
          : "Pagamento Paylogos"
      });

      if (resultado.requestStatus == 1) {
        Swal.fire({
          title: "",
          text:
            "O título foi enviado via remessa pagamento para o banco. Dentro de 10 a 40 minutos estará disponível para a liberação no seu Internet Banking.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false
        });
      } else if (resultado.erro) {
        Swal.fire({
          title: "",
          text: resultado.erro,
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false
        });
      } else {
        Swal.fire({
          title: "",
          text:
            "Não foi possível efetuar o envio da remessa de pagamento. Tente novamente mais tarde ou entre em contato com o suporte.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false
        });
      }
    },
    buscarFluxos() {
      let vm = this;
      vm.updateFgLoading(true);

      this.getFluxosDeCaixa({
        inicio: this.fgDataInicio,
        fim: this.fgDataFim,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador,
        tipo: this.fgModoPR,
        fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
        filtroAbas: this.fgFiltroAbas,
        dataFiltroTipo: this.fgDataFiltroTipo,
        emitente: this.fgEmitente,
        ordenacaoFiltroTipo: this.fgOrdenacaoFiltroTipo
      }).then(function() {
        vm.updateFgLoading(false);
      });
    },
    sairFluxoDetalhado() {
      this.getZeraFluxosDeCaixa({
        inicio: this.fgDataInicio,
        fim: this.fgDataFim,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador,
        tipo: this.fgModoPR,
        fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
        filtroAbas: this.fgFiltroAbas
      });

      this.$nextTick(() => {
        this.buscarFluxos();
      });
    },
    updateDatas(obj) {
      if(obj.startDate) {
        this.updateFgDataInicio(moment(obj.startDate).format("YYYY-MM-DD"));
      }

      if(obj.endDate) {
        this.updateFgDataFim(moment(obj.endDate).format("YYYY-MM-DD"));
      }

      if((obj.startDate) && (obj.endDate)) {
        this.buscarFluxos();
      }
    },
    buscaPorEmitente() {
      this.updatefgEmitente(this.idEmitenteFiltro);
      this.buscarFluxos();
    },
    alterouEmitente(descricao) {
      this.updatefgEmitenteDescricao(descricao);
    }
  }
};
</script>